import useSWR from "swr";

import { api } from "../services";


const BASE_URL = "/system-admin/overtime";
const UPDATE_URL = "/system-admin/overtime/update-status";

export const useOvertimeApplication = ( query = {}) => {
  const qs = new URLSearchParams(query).toString();
  const { data, isLoading, mutate } = useSWR(`${BASE_URL}?${qs}`, api.get);
  const create = async (data) => {
    const ot = await api.post(BASE_URL, data);
    return ot;
  };
  const update = async (data) => {
    const ot = await api.patch(UPDATE_URL, data);
    return ot;
  };
  const find = async (query) => {
    const ot = await api.get(`${BASE_URL}/find?search=${query}`);
    return ot;
  };
  return {
    isLoading,
    data: data,
    count: data?.length,
    create,
    update,
    find,
    mutate,
  };
};